import * as application from './application';
import * as session from './session';

const actions = Object.assign({}, application, session);

export default actions;
